import Swiper from 'swiper';
import 'swiper/css';

const NossosExpertsTime = () => {
    const components = document.querySelectorAll('[data-component="nossos_experts_time"]');

    components.forEach(component => {
        const swiperComponent = component.querySelector('.swiper');

        const swiper = new Swiper(swiperComponent, {
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 42,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
        });
    })
};

export default NossosExpertsTime;

if (document.querySelectorAll('[data-component="nossos_experts_time"]').length) {
    NossosExpertsTime();
}
